import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';


const HeaderBox = (props) => {

    useEffect(() => {        
        if (props.title && !props.ignoreDocumentTitle) {
            document.title = `Arpari | ${props.title}`;
        }
    }, [props.ignoreDocumentTitle, props.title]);

    return (

        <Box
            sx={{
                margin: (theme) => theme.spacing(0),
                backgroundColor: "white",
                border: (theme) => `1px solid ${theme.palette.secondary.light}`,
                borderRadius: 1,
                padding: (theme) => theme.spacing(1),
                minHeight: props.minHeight,
                width: "100%",
                height: "100%"
            }}
        >
            <Stack direction="column"
                divider={<Divider orientation="horizontal" flexItem />}
                sx={{
                    justifyContent: "space-evenly",
                    alignItems: "stretch",
                }}
            >
                <Stack direction="row"
                    sx={{
                        justifyContent: "space-between",
                        alignItems: 'center'
                    }}>

                    <Typography variant="overline" fontSize={props.titleFontSize || 16}>{props.title}</Typography>
                    <Stack direction="row"
                        sx={{
                            justifyContent: "flex-end",
                            alignItems: "center"
                        }}
                        spacing={1}
                    >

                        {props.actions}
                    </Stack>

                </Stack>

            </Stack>
            {props.body && <>
                <Divider />
                {props.body}
            </>}
        </Box>
    )
}

export default HeaderBox;
